var _excluded = ["size", "fill", "className", "spin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { createContext, useContext, useMemo } from 'react';
export var DEFAULT_ICON_CONFIGS = {
  size: '1em',
  rtl: false,
  colors: ['currentColor', '#FFF'],
  prefix: 'adp'
};

function guid() {
  return 'icon-' + ((1 + Math.random()) * 0x100000000 | 0).toString(16).substring(1);
}

export function IconConverter(id, icon, config) {
  var fill = typeof icon.fill === 'string' ? [icon.fill] : icon.fill || [];
  var colors = [];
  var len = Math.max(fill.length, config.colors.length);
  var i = 0;

  while (i < len) {
    if (typeof fill[i] === 'string') {
      colors.push(fill[i]);
    } else {
      if (typeof config.colors[i] !== 'string') {
        throw new Error("config.colors[".concat(i, "] expect string to be HSL"));
      }

      colors.push(config.colors[i]);
    }

    i++;
  }

  return {
    size: icon.size || config.size,
    colors: colors,
    id: id
  };
}
var IconContext = /*#__PURE__*/createContext(DEFAULT_ICON_CONFIGS);
export var IconProvider = IconContext.Provider;
export function IconWrapper(name, rtl, render) {
  return function (props) {
    var size = props.size,
        fill = props.fill,
        className = props.className,
        spin = props.spin,
        extra = _objectWithoutProperties(props, _excluded);

    var ICON_CONFIGS = useContext(IconContext);
    var id = useMemo(guid, []);
    var svgProps = IconConverter(id, {
      size: size,
      fill: fill
    }, ICON_CONFIGS);
    var cls = [ICON_CONFIGS.prefix + '-icon'];
    cls.push(ICON_CONFIGS.prefix + '-icon' + '-' + name);

    if (rtl && ICON_CONFIGS.rtl) {
      cls.push(ICON_CONFIGS.prefix + '-icon-rtl');
    }

    if (spin) {
      cls.push(ICON_CONFIGS.prefix + '-icon-spin');
    }

    if (className) {
      cls.push(className);
    }

    return /*#__PURE__*/React.createElement("span", _objectSpread(_objectSpread({}, extra), {}, {
      className: cls.join(' ')
    }), render(svgProps));
  };
}